import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@docpath/linces-angular-components/common';
import { DpTableModule, Table } from '@docpath/webcomponents';

import { IndexServicesHttpService } from '../../services/index-services-http.service';
import { IndexServicesTableService } from './index-services-table.service';


@Component({
  selector: 'app-index-services-table',
  templateUrl: './index-services-table.component.html',
  standalone: true,
  imports: [DpTableModule]
})
export class IndexServicesTableComponent implements OnInit {

  @Input() filters: Filter[] = [];

  @Output() selectedRow = new EventEmitter<void>();
  @Output() tableLoaded = new EventEmitter<Table>();

  table: Table;
  showLoading = false;

  private readonly indexServicesTableService = inject(IndexServicesTableService);
  private readonly indexServicesHttpService = inject(IndexServicesHttpService);

  constructor() {
    this.table = this.indexServicesTableService.initTable();
  }

  ngOnInit(): void {
    this.indexServicesTableService.indexServicesLoaded.subscribe(result => {
      this.table.header = this.indexServicesTableService.initTableHeader();
      this.table.body = this.indexServicesTableService.initTableBody(result);
    });

    this.indexServicesHttpService.showLoadingChanged.subscribe(showLoading => {
      this.showLoading = showLoading;
    });

    this.indexServicesTableService.loadIndexServices([], 1, 25);

    this.tableLoaded.emit(this.table);
  }

  onChangeCheck(): void {
    this.selectedRow.emit();
  }

  onChangePage(page: number): void {
    this.indexServicesTableService.loadIndexServices(this.filters, page);
  }

  onChangePageSize(size: number): void {
    this.indexServicesTableService.loadIndexServices(this.filters, 1, size);
  }

  getCurrentPage(): number {
    return this.indexServicesTableService.getCurrentPage();
  }

  getElements(): number {
    return this.indexServicesTableService.getElements();
  }

}
